import createCookie from "../utils/createCookie";
import getCookie from "../utils/getCookie";

const audienceController = (cookieName, setOnLoad = true) => {
    // Convert string 'true'/'false' to actual boolean
    const shouldSetOnLoad = setOnLoad === true || setOnLoad === "true";
    return {
        cookieValue: shouldSetOnLoad ? getCookie(cookieName) : null,
        init() {
            this.$watch("cookieValue", value => {
                createCookie(cookieName, value);
                this.$dispatch("set-audience");
            });
        }
    };
};

export default audienceController;
